<!-- =========================================================================================
  File Name: BoardView.vue
  Description: Board View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="board-comment-list">
    <!-- POST COMMENT -->
    <div>
        <div class="flex justify-between">
            <div class="flex items-center">
                <div class="flex items-center">
                  <!-- <feather-icon class="mr-2" icon="MessageSquareIcon" svgClasses="h-5 w-5"></feather-icon> -->
                  댓글 
                  <span class="font-semibold ml-2">{{ commentList.length }}</span>
                </div>
            </div>
        </div>

        <div class="comments-container mt-4">
            <ul class="user-comments-list">
                <li v-for="(commentedUser, commentIndex) in commentList" :key="commentIndex" class="commented-user  border-b-0 border-l-0 border-r-0 border-t d-theme-border-grey-light border-solid flex pt-4 mb-4">
                    <div class="mr-3"><vs-avatar class="m-0" size="30px" /></div>
                    <div class="leading-tight">
                        <p class="font-medium">{{ commentedUser.writerName }}</p>
                        <span class="text-sm" v-html="commentedUser.content"></span>
                        <p class="text-sm" color="#979797">{{ commentedUser.createDate | moment('YYYY-MM-DD HH:mm:ss')}}</p>
                    </div>
                    <div v-if="commentedUser.writerID === getUserInfo.userID" class="ml-auto">
                        <div class="flex">
                          <vs-dropdown vs-custom-content vs-trigger-click class="inline-flex cursor-pointer">
                            <feather-icon icon="MoreVerticalIcon" svgClasses="h-4 w-4" class="mr-2 cursor-pointer"></feather-icon>
                            <vs-dropdown-menu style="z-index: 40001" class="table">
                              <vs-dropdown-item @click="onUpdateComment(commentedUser)">
                                댓글 수정
                              </vs-dropdown-item>

                              <vs-dropdown-item @click="confirmDeleteRecord(commentedUser)">
                                댓글 삭제
                              </vs-dropdown-item>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- <div class="post-comment flex -mx-2 mb-4">
          <div class="w-1/2 px-2">
            <vs-textarea placeholder="댓글 내용" class="mb-2" v-model="commentContent" />
          </div>
          <div class="w-1/2 px-2"> 
            <vs-button  :disabled="!validateForm" @click="onAddComment">댓글<br>등록</vs-button>
          </div>
        </div> -->
        <div class="chat__input flex bg-white">
            <vs-textarea class="flex-1" placeholder="댓글 내용" v-model="commentContent" />
            <vs-button v-html="buttonTxt" v-model="mode" class="bg-primary-gradient ml-4 comment-save" type="filled" :disabled="!validateForm" @click="save"></vs-button>
        </div>
    </div>
    <!-- /POST COMMENT -->
  </div>
</template>

<script>

import { fetchData, postData, putData, deleteData } from '@/api/module'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      boardEntrySeq: this.$route.params.boardEntrySeq,
      board_data: JSON.parse(JSON.stringify(this.data)),
      commentList: [],
      commentContent: '',
      mode: 'ins',
      buttonTxt: '등록',
      boardCommentSeq: 0,
      writerID: this.$store.getters.getUserInfo.userID,
      writerName: this.$store.getters.getUserInfo.name
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.commentContent
    },
    getUserInfo () {
      return this.$store.getters.getUserInfo
    }
  },
  methods: {
    onUpdateComment (commentedUser) {
      
      this.boardCommentSeq = commentedUser.boardCommentSeq
      this.commentContent = commentedUser.content
      this.mode = 'mod'
      this.buttonTxt = '수정'
    },
    async save () {
      if (!this.validateForm) return

      try {

        if (this.mode === 'mod') { //댓글수정

          await putData('/board/comment', {
            boardCommentSeq : this.boardCommentSeq,
            content : this.commentContent,
            
            writerID : this.writerID,
            writerName : this.writerName
          })
          this.fetch_comment_data()
          this.clearFields()
          this.mode = 'ins'
          this.buttonTxt = '등록'

        } else { //댓글등록

          await postData('board/comment', {
            boardEntrySeq : this.boardEntrySeq,
            writerID : this.writerID,
            writerName : this.writerName,
            content : this.commentContent
          })
          this.fetch_comment_data()
          this.clearFields()

        }

      } catch (error) {
        
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    confirmDeleteRecord (commentedUser) {
      this.boardCommentSeq = commentedUser.boardCommentSeq

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '삭제',
        text: '삭제 하시겠습니까?',
        accept: this.deleteRecord,
        acceptText: '삭제'
      })
    },
    async deleteRecord () {
      try {
        await deleteData(`board/${this.boardEntrySeq}/comment/${this.boardCommentSeq}`)
        
        this.fetch_comment_data()

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    clearFields () {
      this.$nextTick(() => {
        this.commentContent = ''
      })
    },
    async fetch_comment_data () {
      try {
        const { data } = await fetchData(`board/comment/${this.boardEntrySeq}`)
        this.commentList = data.list

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }

  },
  created () {
    this.fetch_comment_data()
  }
}

</script>

<style lang="scss">
.comment-save {
  height: 64px;
}

#avatar-col {
  width: 10rem;
}

#page-board-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
